import React from "react";
import { Typography } from "@material-tailwind/react";

interface TitleProp {
  Title: string;
  Subtitle: string;
}

const TitleComponent: React.FC<TitleProp> = ({ Title, Subtitle }) => {
  return (
    <>
      <div className="leading-tight flex flex-col mt-5  ">
        <Typography
          placeholder=""
          className="text-center uppercase leading-tight font-light block antialiased text-gray-800 mb-0 text-lg Blinker-SemiBold"
        >
          {Subtitle}
        </Typography>
        <div className="flex w-full items-center rounded-full ">
          <span className="w-full Blinker-Bold lg:text-[2.7rem] md:text-5xl text-[2rem] px-3 text-gray-800 antialiased block font-light  text-center leading-7">
            {Title}
          </span>
        </div>
      </div>
    </>
  );
};

export default TitleComponent;
